import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { PasswordPolicyService } from 'src/app/services/password-policy.service';
import { Response } from 'src/app/model/response.modal';
import { ToastrService } from 'ngx-toastr'
import { UtilityService } from 'src/app/services/utility.service';
import { CustomField } from 'src/app/model/custom-field.modals';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  @ViewChild('adduserform') public adduserform: NgForm
  maxDate = new Date();
  model: any = { address: {} };
  id: any;
  opt: any;
  rolename: any;
  inputReadonly = true;
  role_id: any
  buttonTitle: String = '';
  title: String = '';
  roleList: any = [];
  value: string;
  config = {
    displayKey: "description", //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: 'auto',//height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
    // customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    // limitTo: options.length ,// a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more',// text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!',// text to be displayed when no items are found while searching
    searchPlaceholder: 'Search', // label thats displayed in search input,
    searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
  }
  test: any = [];
  application: any = [];
  applicationLists: any = [];
  app_id: any;
  password: boolean = true;
  username: any;
  user_id: any;
  usernameValue: string = '';
  nameValue: string = '';
  emailValue: string = '';
  phoneValue: string = '';
  addressValue: string = ''
  passwordPolicy: any;
  passwordError: any = { isError: false, errorMessage: '' };
  response: Response;
  isLoading: boolean
  isSavingData: boolean = false;
  customFields: Array<CustomField> = [];
  customObject = {};
  clientId: any;
  constructor(private authService: AuthService,
    private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private accesscontrolService: AccessControlService,
    private checkPermissionService: CheckPermissionService, private passwordPolicyService: PasswordPolicyService, private toastrService: ToastrService, private utilityService: UtilityService) {
    this.id = this.activatedRoute.snapshot.params['id'];
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt')
    this.clientId = localStorage.getItem("org_id");
    this.fetchCustomFields();
    if (this.opt == 'add') {
      this.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id')
      this.usernameValue = 'username'
      this.nameValue = 'name'
      this.emailValue = 'email'
      this.phoneValue = 'phone'
      this.addressValue = 'address'

    }
    else {
      // this.nameValue = this.activatedRoute.snapshot.queryParamMap.get('option');
      // this.emailValue = this.activatedRoute.snapshot.queryParamMap.get('option');
      this.usernameValue = 'username'
      this.nameValue = 'name'
      this.emailValue = 'email'
      this.phoneValue = 'phone'
      this.addressValue = 'address'
      this.app_id = this.activatedRoute.snapshot.params['app_id'];
    }
    // this.test = ["admin", "manager", "Sysadmin"];
  }

  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.user_id = localStorage.getItem('user_id')
    if (this.opt == 'add') {
      this.password = true;
      this.buttonTitle = 'Save'
      this.title = 'Add User'
    }
    else {
      this.buttonTitle = 'Update'
      this.password = false;
      this.title = 'Edit User'
      this.getuserbyId()
    }

    if (localStorage.getItem("passwordPolicy"))
      this.passwordPolicy = JSON.parse(localStorage.getItem("passwordPolicy") || '');
    // this.listallapplications();
    // this.getapplicationbyId()
    // this.listallRoles_withinApp();

    // this.getPasswordPolicyDetails();

  }
  getPasswordPolicyDetails() {
    this.passwordPolicyService.getPasswordPolicyDetails(localStorage.getItem('application_id')).subscribe((res) => {
      this.passwordPolicy = res;
    },
      error => {
        console.log(
          'Error in getting permissions'
        )
      });
  }
  getapplicationbyId() {
    this.accesscontrolService.getapplicationbyId(this.app_id).subscribe((res) => {
      this.application = res;
      this.model.application_id = this.app_id
      this.model.application_code = this.application.application_code;
      this.model.application_name = this.application.application_name;

    }, error => {
      console.log(error)
    },
      () => {
        this.listallRoles_withinApp();
      })
  }

  listallRoles_withinApp() {
    this.authService.listallRoles_withinApp(this.model.application_code).subscribe((res) => {
      this.roleList = res
    }, error => {

    }, () => {

    })
  }
  getroleName(role_id: any) {
    this.role_id = role_id;
    this.authService.getrolebyId_users(role_id).subscribe((res) => {
      this.rolename = res["name"]
    }, error => {

    }, () => {

    })
  }

  submit(form: NgForm) {
    if (!this.adduserform.valid) {
      return
    }
    if (this.opt == 'add') {
      if (!this.validatePassword())
        this.addUser();
    }
    else {
      this.updateUser();
    }
  }
  validatePassword() {
    debugger;
    if (this.passwordPolicy)
      if (this.passwordPolicy.regexValidators != undefined) {
        if (this.model.password)
          for (var i = 0; i < this.passwordPolicy.regexValidators.length; i++) {
            if (!this.model.password.match(this.passwordPolicy.regexValidators[i].value)) {
              this.passwordError.isError = true;
              this.passwordError.errorMessage = this.passwordPolicy.regexValidators[i].text;
              break;
            } else {
              this.passwordError.isError = false;
            }
          }
      }
    if (!this.passwordError.isError) {
      if (this.model.password.startsWith(" ") || this.model.password.endsWith(" ")) {
        this.passwordError.isError = true;
        this.passwordError.errorMessage = "Password can't start or end with spaces";
      }
    }
    if (this.passwordPolicy)
      if (this.passwordPolicy.enforceCustumList != undefined && this.passwordPolicy.enforceCustumList) {
        var blacklist = this.passwordPolicy.customBannedList[0].split('\n');
        if (blacklist.some(item => item == this.model.password)) {
          this.passwordError.errorMessage = "This Password is in blacklist";
          this.passwordError.isError = true;
        }
      }
    return this.passwordError.isError;
  }
  // listallapplications() {
  //   this.accesscontrolService.listallapplications().subscribe((res) => {
  //     this.applicationLists = res;
  //   }, error => {

  //   }, () => {
  //   })
  // }
  // selected_application(application_id) {
  //   this.app_id = application_id
  //   this.accesscontrolService.getapplicationbyId(application_id).subscribe((res) => {
  //     this.application = res;
  //     this.model.application_id = application_id
  //     this.model.application_code = this.application.application_code;
  //     this.model.application_name = this.application.application_name;
  //   }, error => {
  //     console.log(error)
  //   },
  //     () => {
  //       this.listallRoles_withinApp();
  //     })
  // }
  //register User
  addUser() {
    var signedDate = new Date
    this.model.org_id = this.user_id
    this.model.signed_up = signedDate
    this.model.modified_by = this.user_id;
    this.model.modified_by_name = this.username;
    this.model.orgName = localStorage.getItem('org_name')
    this.isSavingData = true
    this.authService.addUser(this.model).subscribe((res: any) => {
      if (!res.error) {
        this.toastrService.success("User Added Successfully");
        this.router.navigate(['/user-listing']);
      } else {
        if (res.errorCode == "user_exists") {
          Swal({
            title: `User profile already exists with username:${res.user.username} `,//with the email :</i>${res.user.email_id}</i> and username:<i> ${res.user.username} </i> already exists`,
            text: "Do you want to import this profile?",
            width: '40%',
            showCancelButton: true,
            confirmButtonText: 'Yes, Import it!'

          }).then((result) => {
            if (result.value) {
              this.authService.importUserToClient(res.user).subscribe((resp: any) => {
                if (!resp.error) {
                  this.toastrService.success(resp.message);
                  this.router.navigate(['/user-listing']);
                }
                else
                  this.toastrService.error(resp.message);

              })
            }
          })
        } else
          this.toastrService.error(res.message);
      }
      this.isSavingData = false
    }, error => {
      this.isSavingData = false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage)
    }, () => {

    })
  }
  getuserbyId() {
    this.isLoading = true
    this.authService.getuserbyId(this.id).subscribe((res: any) => {
      this.model = res;
      if (res.customFields != undefined) {
        for (const [key, value] of Object.entries(res.customFields)) {
          if (value != undefined || value != "") {
            this.customObject[key] = value;
          }
        }

      }
      this.model.customFields = { ...this.model.customFields, ...this.customObject };
      this.model.password = this.model.confirm = ""
      if (!this.model.address && typeof this.model.adress != 'object') {
        this.model = { ...this.model, ...{ address: {} } };
      }
      this.isLoading = false
    }, error => {
      this.isLoading = false
    },
      () => { })
  }
  updateUser() {
    this.model.modified_by = this.user_id;
    this.model.modified_by_name = this.username;
    this.isSavingData = true
    this.authService.updateUser(this.model).subscribe((res: any) => {
      this.response = res as Response;

      if (!this.response.error) {
        this.model = res
        this.toastrService.success(this.response.successMessage);
        this.router.navigate(['/user-dashboard/' + this.id]);
      } else {
        this.toastrService.error(res.errorMessage);
      }
      if (this.response.error && this.response.status == 409) {
        this.toastrService.error('Email already exists.')
      }
      this.isSavingData = false
    }, error => { this.isSavingData = false },
      () => {

      })
  }
  cancel() {
    if (this.opt == 'add') {
      this.router.navigate(["/user-listing"])
    }
    else {
      this.router.navigate(['/user-dashboard/' + this.id]);
    }

  }
  fetchCustomFields() {
    this.utilityService.fetchCustomFields(this.clientId, true).subscribe((res: any) => {
      this.customFields = res.fields as Array<CustomField>;
      if (this.customFields.length > 0)
        this.model['customFields'] = this.model['customFields'] || {};
      this.customFields.forEach((field: CustomField) => {
        if (!(this.model.customFields && this.model.customFields[field.name]))
          Object.defineProperty(this.model['customFields'], field.name, {
            value: field.default ? field.default : "",
            writable: true,
            enumerable: true
          })
      })
      this.customObject = this.model.customFields;
    })
  }
}

